<template>
  <div class="box text-center">
    <!-- /.box-header -->
    <div class="box-body">
      <div class="col-xs-12">
        <div class="inline-block pull-left">
          <h4 class="pull-left">
          商品與組合價格
          </h4>
        </div>
      </div>
      <div class="col-xs-12 p-10 grid">
        <div class="grid" style="width: 100%;">
          <div class="col-xs-12 col-lg-4 grid-item p-5" v-for="(c, index) in category" v-if="category.length">
            <div class="col-xs-12 card">
              <div class="col-xs-12 card-title text-left p-x-15">
                <span class="pull-left">{{c.name}}</span>
              </div>
              <div class="col-xs-12 text-left">
                <ul class="nav p-x-15">
                  <li class="card-product c-pointer" v-for="(p, index) in c.product_list" @click="openCombineModal('info', p.name, p.product_id)">
                    <div class="product-name inline-block">{{p.name}}</div>
                    <div class="inline-block">
                      <!--&nbsp;&nbsp;<i class="fa fa-info-circle c-pointer " aria-hidden="true" data-toggle="modal"></i>-->
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 text-center">
        <ul class="pagination">
          <li class="paginate_button" v-if="pageAmount > 1 && pageGroup !== 1" @click="pageGroup = pageGroup - 1">
            <a class="c-pointer"><i class="fa fa-angle-double-left" aria-hidden="true"></i></a>
          </li>
          <li class="paginate_button" v-for="index in pageAmount" :class="{active: isActive(index)}" @click="getMenuCategory(index)" v-if="pageShow(index)">
            <a class="c-pointer">{{index}}</a>
          </li>
          <li class="paginate_button" v-if="pageAmount > 1 && pageAmount / groupAmount > pageGroup" @click="pageGroup = pageGroup + 1">
            <a class="c-pointer"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a>
          </li>
        </ul>
      </div>
    </div>
    <div class="box-footer text-center">
      <button class="btn btn-success" @click="gotoFrom">
        上一步
      </button>
      <button class="btn btn-default" @click="gotoNext">
        離開
      </button>
    </div>
    <br />
    <!-- 1 = add, 2 = edit, 3 = info -->
    <combine-price-modal modalId="crCombineModal" :state="1" :productId="current.productId" :productName="current.productName" :type="current.type"/>
    <combine-price-modal modalId="infoCombineModal" :state="3" :productId="current.productId" :productName="current.productName" :type="current.type"/>
  </div>
</template>
<script>
import $ from 'jquery'
import Masonry from 'masonry-layout'
import CombinePriceModal from './CombinePriceModal.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    'combine-price-modal': CombinePriceModal
  },
  props: {
    'info': {
      type: Object
    }
  },
  data () {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      menuId: this.$route.params.menu_id,
      brandId: this.$route.params.brand_id,
      current: {
        productId: 0,
        category: 0,
        categoryId: 0,
        categoryName: '',
        type: ''
      },
      category: [],
      cateNumList: [],
      product: {},
      amount: {
        category: 1,
        product: 1
      },
      count: 20,
      maxTotal: 0
    }
  },
  methods: {
    ...mapActions(['setUpCategory', 'setModal']),
    init () {
      if (typeof this.info !== 'undefined') {
        this.brandName = this.info.name
        this.brandType = this.info.type
      }
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    showMenu () {
      if ($('.grid') && $('.grid-item')) {
        var m = new Masonry('.grid', {
          itemSelector: '.grid-item',
          columnWidth: '.grid-item'
        })
        m.reloadItems()
        m.layout()
      }
    },
    getProduct (index) {
      return this.product[index]
    },
    openCombineModal (type, name, pId) {
      this.setModal(true)
      this.current.productId = parseInt(pId, 10)
      this.current.productName = name
      this.current.type = type
      if (type === 'cr') $('#crCombineModal').modal('toggle')
      else if (type === 'info') $('#infoCombineModal').modal('toggle')
    },
    gotoFrom () {
      this.$router.push('/upCombination/' + this.brandId)
    },
    gotoNext () {
      this.$router.push('/brandMenu/' + this.brandId)
    },
    getMenuCategory (index) {
      var self = this
      if (index) this.tableIndex = this.amount.category = index
      var url = 'brand/' + this.$route.params.brand_id + '/category/list?page=' + this.amount.category + '&size=' + this.count
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.category = response.data.category_list
          self.maxTotal = response.data.meta.total
          for (let i = 0; i < response.data.category_list.length; i++) {
            self.cateNumList.push(response.data.category_list[i].category_id)
          }
          self.getProducts()
          self.setUpCategory(false)
        }
      })
    },
    getProducts () {
      if (this.cateNumList.length) {
        for (let i = 0; i < this.cateNumList.length; i++) {
          this.productByCId(this.cateNumList[i], 0)
        }
      }
    },
    productByCId (categoryId, index) {
      var page = 1
      if (index) page = index
      var self = this
      if (categoryId) {
        var url = 'brand/' + this.$route.params.brand_id + '/category/' + categoryId + '/productlist?page=' + page + '&size=' + this.count
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var categoryId = response.data.meta.category_id
            self.category.filter(function (elem, index, obj) {
              if (elem.category_id === categoryId) {
                self.$set(elem, 'product_list', response.data.product_list)
                self.$set(elem, 'product_total', response.data.meta.total)
                self.$set(elem, 'page', page)
              }
              return elem.category_id === categoryId
            })
          }
        })
      }
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    }
  },
  created () {
    this.getMenuCategory()
  },
  mounted () {
    this.showMenu()
  },
  computed: {
    ...mapGetters(['getUpCategory', 'getModal']),
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    },
    productNew () {
      var product = this.product
      return product
    },
    pageAmount () {
      return Math.ceil(this.maxTotal / this.count)
    }
  },
  updated () {
    var self = this
    this.showMenu()
    setTimeout(function () {
      self.showMenu()
    }, 1000)
  },
  watch: {
    getUpCategory () {
      if (this.getUpCategory) {
        this.cateNumList = []
        this.getMenuCategory(1)
      }
    },
    getModal () {
      if (!this.getModal) {
        this.current = {
          productId: 0,
          category: 0,
          categoryId: 0,
          categoryName: ''
        }
      }
    }
  }
}
</script>
<style lang="sass">
$default-color: #e1456d
$light-gray: rgb(238, 238, 238)
.btn-add-combine
  right: 0px
  top: -4px
.product-name
  float: left
  max-width: calc(100% - 120px)
  text-overflow: ellipsis
  overflow: hidden
  white-space: nowrap
</style>



// WEBPACK FOOTER //
// CrCombinationPriceTemp.vue?41f5b448